import { locales } from 'config'

const proLegacyUrl = (locale, section) => locales[locale].proLegacyUrls[section]

export default proLegacyUrl
